import { useEffect, useState } from 'react'
import { protectionAddOns } from '../../data/protection-addons'
import type { SelectedProtection } from '../../data/protection-catalog'
import {
  buildProtectionBookHref,
  readSelectedProtection,
} from '../../lib/selected-protection'
import { ButtonLink } from '../ui/button'

export interface CompleteProtectionPreviewProps {}

export function CompleteProtectionPreview(_: Readonly<CompleteProtectionPreviewProps>) {
  const [selection, setSelection] = useState<SelectedProtection | null>(null)

  useEffect(() => {
    setSelection(readSelectedProtection())
  }, [])

  return (
    <section className="complete-protection-section" id="complete-protection" aria-labelledby="complete-protection-heading">
      <div className="section-container">
        <div className="center-heading">
          <p className="eyebrow">Optional Add-ons</p>
          <h2 id="complete-protection-heading">Complete Your Protection</h2>
          <p>
            Wheels, glass, trim and interior protection can be added in the next booking step, or
            discussed during your complimentary inspection.
          </p>
        </div>
        <div className="addon-preview-grid">
          {protectionAddOns.map((item) => (
            <article className="addon-preview-card" key={item.id}>
              <h3>{item.shortName}</h3>
              <p>{item.description}</p>
              {item.surfaces ? (
                <p className="addon-surfaces">Available for: {item.surfaces.join(' · ')}</p>
              ) : null}
            </article>
          ))}
        </div>
        <div className="gallery-action">
          <ButtonLink href={selection ? buildProtectionBookHref(selection) : '/book'}>
            {selection ? 'Continue to Booking' : 'Book Ceramic Protection'}
          </ButtonLink>
        </div>
      </div>
    </section>
  )
}
